<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
        {{currentYear}} © Buymore Infotech.
      </div>
      <div class="col-sm-6">
        <div class="text-sm-end d-none d-sm-block">
          Crafted with <i class="mdi mdi-heart text-danger"></i> by Buymore Infotech
        </div>
      </div>
    </div>
  </div>
</footer>
